// Ícone "glitch" da Twitch. Branco (monocromático) por padrão; colorido (roxo #9146FF com interior branco) quando ativo.
export function TwitchIcon({ size = 20, active = false, className = "", style, title = "Twitch", ...rest }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={`inline-block flex-shrink-0 ${className}`}
      style={{ width: size, height: size, ...style }} role="img" aria-label={title} {...rest}>
      {active && <path fill="#FFFFFF" d="M6.857 1.714h13.714v9.429l-3.428 3.428h-3.429l-3 3v-3H6.857z" />}
      <path fill={active ? "#9146FF" : "#FFFFFF"}
        d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0 1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
    </svg>
  );
}

export default TwitchIcon;
